import React, { useCallback, useState } from 'react'
import { IProductBase } from 'product/IProduct'
import { Col } from 'react-bootstrap'
import Accordion from 'components/accordion/Accordion'
import ProductReservesList from './ProductReservesList'

interface IDescriptionReservesViewProps {
  product: IProductBase
  order?: number
  className?: string
}

const DescriptionReservesView: React.FC<IDescriptionReservesViewProps> = ({
  product,
  order,
  className,
}) => {
  const [showDescription, setShowDescription] = useState(false)
  const [showReserves, setShowReserves] = useState(false)

  const handleShowDescription = useCallback((show) => {
    setShowDescription(show)
    setShowReserves(false)
  }, [])

  const handleShowReserves = useCallback((show) => {
    setShowReserves(show)
    setShowDescription(false)
  }, [])

  return (
    <Col xs={{ span: 12, order }} className={className}>
      <div className='d-flex gap-5'>
        <Accordion
          header='Подробности'
          isOpen={showDescription}
          onToggle={handleShowDescription}
        />
        <Accordion header='Наличие' isOpen={showReserves} onToggle={handleShowReserves} />
      </div>

      {showDescription && <div dangerouslySetInnerHTML={{ __html: product.info_html }} />}

      {showReserves && product.reserves && (
        <ProductReservesList reserves={product.reserves} />
      )}
    </Col>
  )
}
export default DescriptionReservesView
